import React, { useEffect, useState } from 'react'
import cloudIcon from "./cloudIcon.png";
const WetherApp = () => {
    const [Input, setInput] = useState("")
    const [city, setcity] = useState("pune")
    const [totalInfo, settotalInfo] = useState("");

    const date = `${totalInfo.sys ? totalInfo.sys.sunrise : null}`
    const date1 = new Date(date * 1000)
    const sunrise = "0" + date1.getHours() + ":" + date1.getMinutes() + ":" + date1.getSeconds();
    console.log(sunrise)

    useEffect(() => {
        const FetchApi = async () => {
            const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=94e91f954536fdecfb941dfecddafac9&units=metric`;
            const Responce = await fetch(url);
            const ResponceJson = await Responce.json();
            console.log(ResponceJson)
            settotalInfo(ResponceJson)
        }
        FetchApi();
    }, [city]);

    return (
        <>
            <div className='MainContainer'>

                <div className="innerContainer">
                    <div className="searchbox">
                        <div className='searchcon'>
                            <input type="text" placeholder='Enter City..' onChange={(e) => { setInput(e.target.value) }} className="input" />
                            <button className='searchbtn' onClick={() => { setcity(Input) }}><i class="fa-solid fa-magnifying-glass"></i></button>
                        </div>
                    </div>
                    <div className="imgwether">
                        {totalInfo.main ? <span>{totalInfo.main.temp} <sup>o</sup>C <>| {totalInfo.weather ? <sub>{totalInfo.weather.map(e => e.description)}</sub> : null}</> </span> : <p></p>}
                        <span><img src={cloudIcon} alt="" className='cloudIcon' /></span>
                    </div>
                    <div className="cityname">
                        {totalInfo.name ? <span><h2>{totalInfo.name}, </h2></span> : <p>No city Found</p>}
                        {totalInfo.sys ? <span><h4>{totalInfo.sys.country}</h4></span> : null}
                    </div>
                    <h4 className='WetherInfo'>Wether Info</h4>
                    <div className="WetherData">
                        <div className="one">
                            <div className="sunri">
                                <span><i className="fa-solid fa-sun ug"></i>sunrise</span>
                                <span className='sundate'>{totalInfo.sys ? <p className='sundate'>{sunrise}</p> : null}</span>
                            </div>
                            <div className="humi">
                                <span><i class="fa-solid fa-droplet ug"></i>Humidity</span>
                                <span className='sundate1'>{totalInfo.main ? <p className='sundate'>{totalInfo.main.humidity}</p> : null}</span>  </div>
                        </div>
                    </div>
                    <div className="two">
                        <div className="sunri">
                            <span><i class="fa-solid fa-water ug"></i>wind</span>
                            <span className='sundate'>{totalInfo.wind ? <p className='sundate'>{totalInfo.wind.gust}</p> : null}</span>
                        </div>
                        <div className="humi">
                            <span><i class="fa-solid fa-power-off ug"></i>Presssure</span>
                            <span className='sundate1'>{totalInfo.main ? <p className='sundate'>{totalInfo.main.pressure}</p> : null}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}



export default WetherApp